import React, { useEffect, useState } from 'react';
import Loader from '../../pages/utilities/loader';
import { FaTh } from 'react-icons/fa';
import { FcFolder } from "react-icons/fc";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { TiThListOutline } from "react-icons/ti";
import { TbArrowsSort } from "react-icons/tb";
import { FaFilePdf } from "react-icons/fa";
import { FaRegFileImage } from "react-icons/fa";
import { ImImage } from "react-icons/im";
import { Alert } from 'antd';
import getFilesExplorer from '../../api/getFilesExplorer';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import checkFilesExplorer from '../../api/checkFilesExplorer';
import DocumentModal from '../Form/components/DocumentModal';
import { useDispatch } from 'react-redux';
import { updateTitle } from '../../redux/updatePageHeadeSlice';
import { FILES_EXPLORER } from '../../constants/headerTitles';

const getDocumentType = (file_name) => {
    let file_extension
    if (file_name.includes('.pdf')) {
        file_extension = 'PDF'
    } else if (file_name.includes('.jpeg')) {
        file_extension = 'JPEG'
    } else if (file_name.includes('.png')) {
        file_extension = 'PNG'
    } else {
        file_extension = 'FILE'
    }

    return file_extension
}

const transformData = (data) => {
    const result = {};

    data.forEach((item) => {
        const idKeys = Object.keys(item._id);
        let currentLevel = result;

        idKeys.forEach((key, index) => {
            const keyValue = item._id[key] || 'InvalidFolder';
            if (!currentLevel[keyValue]) {
                currentLevel[keyValue] = { type: 'folder', name: keyValue, subfolders: {} };
            }

            if (index === idKeys.length - 1) {
                if (!currentLevel[keyValue].documents) {
                    currentLevel[keyValue].documents = [];
                }
                item.documents.forEach((doc) => {
                    currentLevel[keyValue].documents.push({
                        _id: doc._id,
                        type: 'file',
                        name: doc.image_name,
                        datetime_insertion: doc.datetime_insertion,
                        last_modification_date: doc.last_modification_date,
                        form_name: doc.form_name,
                        project_name: doc.project_name,
                        doc_type: getDocumentType(doc.image_name)
                    });
                });
            }

            currentLevel = currentLevel[keyValue].subfolders;
        });
    });

    return result;
};

const Folder = ({ data }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fileExplorer, setFileExplorer] = useState([]);
    const selectedProject = useSelector(state => state.selectedProject);
    const selectedForm = useSelector(state => state.selectedForm)
    const [checkFileExplorerResponse, setCheckFileExplorerResponse] = useState(null);
    const [isListView, setIsListView] = useState(false); // Toggle state
    const [sortType, setSortType] = useState(null);
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(updateTitle(FILES_EXPLORER))
    }, [])

    const { result } = useQuery(
        ["getFileExplorer"],
        () => getFilesExplorer(selectedProject.name, selectedForm.form_name),
        {
            enabled: true,
            onSuccess: (data) => {
                setFileExplorer(data.data.data);
            },
            onError: (err) => {
                console.log("error", err)
            }
        }
    );

    const { response } = useQuery(
        ["checkFileExplorer"],
        () => checkFilesExplorer(selectedProject.name),
        {
            enabled: true,
            onSuccess: (data) => {
                setCheckFileExplorerResponse(data.data.data);

            },
            onError: (err) => {
                console.log("error", err)
            }
        }
    );

    const directoryData = [
        {
            name: 'Dossier 1',
            type: 'folder',
            children: [
                {
                    name: 'Sous-dossier 1',
                    type: 'folder',
                    children: [
                        { name: 'Document 1', type: 'file' },
                        { name: 'Document 2', type: 'file' },
                    ],
                },
                { name: 'Sous-dossier 2', type: 'folder' },
            ],
        },
        { name: 'Dossier 2', type: 'folder' },
    ];


    const toggleView = () => {
        setIsListView(!isListView);
    };

    const toggleSort = () => {
        setSortType((prev) => {
            if (prev === 'asc') return 'desc';
            if (prev === 'desc') return null;
            return 'asc';
        });
    };


    if (isLoading) return <><Loader /></>

    return (
        <>
            <div className='px-6'>
                <div className="h-full flex flex-col gap-2 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h7>Dans cette section, retrouvez vos documents rangés par dossier, afin de  donner plus de sens à vos archives</h7>
                    </div>
                    {checkFileExplorerResponse ? <Alert
                        message="Informations"
                        description={checkFileExplorerResponse}
                        type="warning"
                    /> : ''}
                </div>
                <div>
                    <div className="mb-2 flex justify-en gap-6 w-full">
                        <button onClick={toggleView} className="inline-flex items-center gap-1">
                            <span className='text-white p-2 bg-gray-400 border'>{isListView ? <TiThListOutline /> : <FaTh />}</span> <span>Afficher</span> {/* Toggle icon */}
                        </button>
                        <button onClick={toggleSort} className="inline-flex items-center gap-1">
                            <span className="text-white p-2 bg-gray-400 border">
                                <TbArrowsSort />
                            </span>
                            <span>Trier</span>
                        </button>
                    </div>
                    <FileExplorer data={fileExplorer} isListView={isListView} sortType={sortType} />
                </div>
            </div>
        </>
    );
}

const FileExplorer = ({ data, isListView, sortType }) => {
    const history = useHistory()
    const [currentPath, setCurrentPath] = useState('');
    const [ModalType, setModalType] = useState("");
    const transformedData = transformData(data);

    const [showModal, setShowModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const getCurrentFolder = (path) => {
        return path.split('/').filter(Boolean).reduce((acc, key) => {
            return acc.subfolders[key];
        }, { subfolders: transformedData });
    };

    const handleClose = () => {
        setShowModal(false)
        setSelectedDocument(null)
    };

    const currentFolder = getCurrentFolder(currentPath);

    const handleFolderClick = (path) => {
        setCurrentPath(path);
    };

    const handleNavigate = (path) => {
        setCurrentPath(path);
    };

    const sortedFolders = sortItems(Object.entries(currentFolder.subfolders).map(([key, folder]) => ({
        key,
        folder
    })), sortType);

    const sortedDocuments = currentFolder.documents ? sortItems([...currentFolder.documents], sortType) : [];

    const handleShowDoc = (doc) => {
        setModalType("");
        setSelectedDocument(doc)
    }

    useEffect(() => {
        if (selectedDocument) {
            setShowModal(true);
        }
    }, [selectedDocument]);

    return (
        <div>
            <div className='mb-2'>
                <Breadcrumb path={currentPath} onNavigate={handleNavigate} />
            </div>
            <div className={`grid ${isListView ? 'grid-cols-1 gap-1 w-full' : 'grid-cols-6 gap-4'}`}>
                {sortedFolders.map(({ key, folder }) => (
                    <FileItem
                        key={key}
                        item={folder}
                        isListView={isListView}
                        onClick={() => handleFolderClick(`${currentPath}/${key}`)}
                    />
                ))}
                {sortedDocuments.map((doc, index) => (
                    <FileItem key={index} item={doc} isListView={isListView} onClick={() => handleShowDoc(doc)} />
                ))}
            </div>

            {selectedDocument && showModal && (
                <DocumentModal
                    selectedDocument={selectedDocument}
                    show={showModal}
                    handleClose={handleClose}
                    ModalType={ModalType}
                    document_status={'VALIDATED'}
                />
            )}

        </div>
    );
};

const FileItem = ({ item, onClick, isListView }) => (
    <div
        className={`cursor-pointer p-2 bg-gray-100 hover:bg-gray-200 rounded flex ${isListView ? 'flex-row' : 'flex-col'}`}
        onClick={onClick}
    >
        <div className={`flex ${isListView ? 'flex-row' : 'flex-col'} gap-1 items-center w-full`}>
            <span className={`mr-1 ${isListView ? 'text-3xl' : 'text-7xl'}`}>
                {item.type === 'folder' ? <FcFolder /> : item.doc_type === 'PDF' ? <FaFilePdf className='text-red-600' /> : item.doc_type === 'JPEG' ? <ImImage className='text-blue-400' /> : <FaRegFileImage className='text-red-600' />}
            </span>
            <span className={`font-light ${isListView ? 'text-sm' : 'text-sm'}`}>{item.name}</span>
        </div>
        {item.type === 'file' && isListView && (
            <div className="flex flex-col items-end text-xs text-gray-500 mt-1 w-full">
                <div>Inserted: {item.datetime_insertion}</div>
                <div>Last Modified: {item.last_modification_date || item.datetime_insertion}</div>
            </div>
        )}
    </div>
);

const Breadcrumb = ({ path, onNavigate }) => {
    const pathParts = path.split('/').filter(Boolean);

    return (
        <div className="p-2 text-sm">
            <span
                className="cursor-pointer text-gray-500 hover:underline"
                onClick={() => onNavigate('')}
            >
                Accueil
            </span>
            {pathParts.map((part, index) => (
                <span key={index}>
                    {' / '}
                    <span
                        className="cursor-pointer text-gray-500 hover:underline"
                        onClick={() => onNavigate(pathParts.slice(0, index + 1).join('/'))}
                    >
                        {part}
                    </span>
                </span>
            ))}
        </div>
    );
};

const sortItems = (items, sortType) => {
    switch (sortType) {
        case 'asc':
            return items.sort((a, b) => a.folder ? a.folder.name.localeCompare(b.folder.name) : a.name.localeCompare(b.name));
        case 'desc':
            return items.sort((a, b) => b.folder ? b.folder.name.localeCompare(a.folder.name) : b.name.localeCompare(a.name));
        default:
            return items;
    }
};


export default Folder;
